// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favorite-asset.clickable[data-v-0105051b]{cursor:pointer}.favorite-asset.clickable[data-v-0105051b]:hover{opacity:.8}", ""]);
// Exports
module.exports = exports;
